import axios from "axios";
const URI = process.env.REACT_APP_FILEUPLOAD_URL;

export const fetchImages = async (id) => {
	return await axios
		.get(`${URI}/fetch/${id}`)
		.then((res) => res.config.url)
		.catch((err) => err.response);
};